import { getRequestConfig } from 'next-intl/server';

// List of supported locales
export const locales = ['en', 'es', 'fr', 'de', 'pt', 'zh', 'ja', 'ar'];
export const defaultLocale = 'en';

export default getRequestConfig(async ({ locale }) => {
  // Validate that the incoming `locale` parameter is valid
  if (!locales.includes(locale)) {
    locale = defaultLocale;
  }

  return {
    messages: (await import(`./messages/${locale}.json`)).default
  };
});
